import { render, staticRenderFns } from "./SidebarBlog.vue?vue&type=template&id=19554c4c&scoped=true&"
import script from "./SidebarBlog.vue?vue&type=script&lang=js&"
export * from "./SidebarBlog.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBlog.vue?vue&type=style&index=0&id=19554c4c&prod&scoped=true&lang=scss&"
import style1 from "./SidebarBlog.vue?vue&type=style&index=1&id=19554c4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19554c4c",
  null
  
)

export default component.exports